import React, { useContext } from 'react';
import styles from './SuccessMessage.module.css';
import successtickmark from "../../assets/successtickmark.png";
import { useNavigate } from 'react-router-dom';
import { LanguageContext } from '../LanguageContext/LanguageContext';
import auth from '../../Auth/Auth';

const lmsUrl = import.meta.env.VITE_LMS_URL;

function SuccessMessage() {
  const {direction} = useContext(LanguageContext); // Get the direction from context
  const navigate = useNavigate();

  const handleStartLearning = () => {
    if (auth.isAuthenticated()) {
      navigate('/home/Dashboard');
    } else {
      navigate('/home/login');
    }
  };

  return (
    <div className={styles.maincontainer} dir={direction}>
      <div className={styles.secondcontainer}>
        <header className={styles.header}>
          <img src={successtickmark} alt="successmark" className={styles.resetlogo} />
        </header>
        <form className={styles.form}>
          {direction === 'rtl' ? (
            <>
              <h2>تم التسجيل بنجاح!</h2>
              <h3>
                مبروك! لقد أكملت تسجيلك في الدورة بنجاح.<br /><br />
                للوصول إلى دورتك، الرجاء تسجيل الدخول إلى حسابك.<br />
                تم إرسال بيانات الدخول إلى بريدك الإلكتروني.<br /><br />
                استعد للانطلاق في عالم صناعة الأفلام — نحن متحمسون لانضمامك إلينا!
              </h3>
              <button style={{ margin: '10px' }} className={styles.btn} type="button">
                <a href="/home/transaction" style={{ textDecoration: 'none', color: 'inherit' }}>تحميل الفاتورة</a>
              </button>
              <button style={{ margin: '10px' }} className={styles.btn} type="button" onClick={handleStartLearning}>
              ابدأ التعلم
              </button>
            </>

          ) : (
            <>
              <h2>Enrollment Successful!</h2>
              <h3>
                Congratulations — you’ve successfully enrolled in the course!<br /><br />
                To access your course, please sign in to your account. Your login details have been sent to your email.<br /><br />
                Get ready to dive into the world of filmmaking — we’re thrilled to have you on board!
              </h3>
              <button style={{ margin: '10px' }} className={styles.btn} type="button">
                <a href="/home/transaction" style={{ textDecoration: 'none', color: 'inherit' }}>Download Invoice</a>
              </button>
              <button style={{ margin: '10px' }} className={styles.btn} type="button" onClick={handleStartLearning}>
                Start Learning
              </button>
            </>
          )}
        </form>
      </div>
    </div>
  );
}

export default SuccessMessage;
//SuccessMessage component to display a success message after enrollment.